export enum EditModeStatus {
  Enabled = 'Enabled',
  Blocked = 'Blocked',
}
